import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOutboundCall = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 13 13",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "m7.49 4.646 3.428-3.427H9.75a.608.608 0 0 1-.61-.61c0-.337.272-.61.61-.61h2.64c.338 0 .61.273.61.61v2.64c0 .339-.272.61-.61.61a.608.608 0 0 1-.609-.61V2.08L8.354 5.51a.61.61 0 0 1-.86-.86l-.004-.003ZM2.983.036a1.012 1.012 0 0 1 1.204.588l1.016 2.438c.172.414.053.894-.295 1.176L3.656 5.263a8.581 8.581 0 0 0 4.08 4.08L8.76 8.093a1.013 1.013 0 0 1 1.175-.295l2.438 1.016c.472.195.724.71.589 1.203l-.61 2.235c-.119.442-.52.749-.977.749C5.093 13 0 7.906 0 1.625c0-.457.307-.858.749-.98l2.234-.61Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h13v13H0z"
		})
	}) })]
});
export default SvgIconOutboundCall;
